function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-27.3 -106.69)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m137.93 356.4c0 19.21 8.54 52.3 0 57.64s-71.52 57.64-89.67 87.53-59.77 104.6 70.45 138.76 318.09 60.84 500.62-162.24c3-3.67 5.79-7.28 8.41-10.84 23.16-4.88 42.58-10 56.7-14.78 100.34-34.16 87.56-53.37 86.46-71.47s3.2-38.43 3.2-56.57c-34.73-28.63-142.73-34.56-252.85-32.21-127.25-23.7-308.31 1.01-383.32 64.18z",
  fill: "#212126",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m658 423.1c-7-2.17-31.41 9.07-57.61 21.14-22.47 10.36-46.22 21.3-63.85 25.48-23.8 5.65-87.46 18.56-152.29 22.73-39.79 2.55-80.09 1.8-112.12-6l-11.68-2.81c-80.01-19.13-137.25-32.84-119.45-117.33l11.92 2.48c-15.39 72.95 37 85.51 110.33 103.06l11.75 2.82c30.65 7.42 69.73 8.11 108.5 5.62 63.86-4.1 126.72-16.86 150.24-22.44 16.53-3.92 39.67-14.58 61.55-24.67 28.4-13.08 54.8-25.25 66.3-21.72z",
  fill: "#c29e33"
}), /*#__PURE__*/React.createElement("path", {
  d: "m578.61 454.15c-15.3 6.77-30.09 12.73-42.06 15.57-15.76 3.74-49 10.67-88.49 16.13 31.75-6.23 58.51-14 76-20.47 16.92-6.21 35.89-9.17 54.53-11.23zm-389.13 9.15c-39-16-60.29-40.9-48.46-97l4.17.87c-1 27.85-.25 50.05 11.48 68.07 6.69 10.27 17.05 19.5 32.81 28.05z",
  fill: "#7d661c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m673.83 442.75c-12.33 17.42-41.83 20.25-75.08 23.39-23.4 2.23-48.74 4.64-69.9 12.41-30.61 11.24-88.76 26.61-152.77 31-44.11 3-91.07.84-133.89-11.47-53.25-15.31-80.92-32.62-95.14-54.46-14.38-22.09-14.59-47.74-13.25-80.17l12.16.47c-1.25 30.22-1.14 54 11.29 73.07 12.58 19.32 38.19 35 88.28 49.36 41.33 11.88 86.87 14 129.74 11 62.66-4.29 119.49-19.3 149.38-30.27 22.56-8.28 48.76-10.78 73-13.08 30.26-2.88 57.17-5.44 66.26-18.29l10 7z",
  fill: "#c29e33"
}), /*#__PURE__*/React.createElement("path", {
  d: "m133.23 417.35c0 3.9 4.69 21.93 11.38 28.34s6.69 1.67 12-3.9 8.36-7 11.7-5.86 3.92-3-2.49-9.38-8.88-9.11-10.05-14.55-2.59-11.67-12.05-8.3-13.35.91-10.47 13.65z",
  fill: "#7d661c",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m476.27 466.52c-4.47 0-9.3 4.1-3.72 14.51s5.95 16.37 17.11 13 52.82-14.51 59.88-16.74 1.49-6.69 0-15.62.38-11.16-8.18-10-41.29 10-65.09 14.87z",
  fill: "#7d661c",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m134.23 365.63c-25.16-29.47-38.4-87.78-26.06-120.7s23.32-26.05 24.69-45.26 37-60.34 102.87-74.06 246.87-30.17 377.17-8.23 170.1 50.75 168.7 80.92-20.6 54.86-9.6 75.44 11.36 45.77-5.49 65.83c-28.8 34.29-197.5 54.86-277 64.46s-146.74 39.52-233.21 16.46c-82.3-21.95-106.21-36.29-122.07-54.86z",
  fill: "#a8b5c2",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m149.82 354.79c-23.89-27.31-36.46-81.34-24.74-111.85s22.13-24.14 23.44-41.94 35.16-55.92 97.66-68.63 234.4-28 358.11-7.63 161.47 47 160.17 75-19.54 50.84-9.12 69.9 10.79 42.42-5.21 61c-27.34 31.77-187.51 50.84-263 59.74s-139.31 36.62-221.42 15.25c-78.13-20.34-100.83-33.63-115.89-50.84z",
  fill: "#fff",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m124.66 218.79a10.8 10.8 0 0 0 -2.28 5.35 11.21 11.21 0 0 0 2.69 8.31c2.31 2.88 6.07 5.53 11.43 7.56 8.9 3.35 22 4.9 40 2.9 24.93-2.77 56 .33 86.52 5.51s60.28 12.36 83 17.86c36.4 8.83 85.63 6 135.05 3.15 11.44-.66 22.9-1.32 34.38-1.84 37-1.68 126.8-10.48 192.18-27.48 40.35-10.5 71.2-23.91 73.68-40.26h.32a87.59 87.59 0 0 1 -1.42 11.93c-11.37 13.26-38.36 24.07-71.43 32.67-65.73 17.09-156 25.94-193.13 27.63-11.23.51-22.79 1.18-34.34 1.84-49.73 2.86-99.29 5.72-136.37-3.27-22.58-5.48-52.34-12.66-82.64-17.8s-60.82-8.18-85.27-5.47c-18.75 2.09-32.6.41-42.11-3.17-6.18-2.33-10.6-5.49-13.39-9a16.49 16.49 0 0 1 -3.64-8.21 68.82 68.82 0 0 1 6.78-8.31z",
  fill: "#a8b5c2"
}), /*#__PURE__*/React.createElement("path", {
  d: "m221.8 250c39.68 2.83 114.92 63 116.79 124.57 1.55 51.39-39.71 57.61-90.32 45.93s-87.2-24.91-84.87-81.75 32.66-90.55 58.4-88.75z",
  fill: "#212126",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#c29e33"
}, /*#__PURE__*/React.createElement("path", {
  d: "m222.73 268.41c1.32.61.42 5.34-2 10.57s-5.47 9-6.79 8.35-.42-5.34 2-10.57 5.46-9 6.78-8.35z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m207.52 275.13c1.27 0 2.43 4 2.59 9s-.73 9.13-2 9.18-2.43-4-2.59-9 .73-9.13 2-9.17z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m225.6 289.09c.48 1.17-2.9 3.67-7.56 5.57s-8.82 2.5-9.3 1.32 2.9-3.67 7.56-5.57 8.82-2.5 9.3-1.32z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m199.86 281.17c1.43-.26 3.44 4.13 4.48 9.8s.73 10.49-.7 10.75-3.44-4.12-4.49-9.79-.72-10.49.71-10.76z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m223.36 301.39c.25 1.36-3.91 3.26-9.28 4.25s-9.93.68-10.18-.67 3.9-3.26 9.28-4.25 9.93-.68 10.18.67z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m194.08 291.21c1.62-.4 4.22 4.48 5.82 10.89s1.57 11.95-.05 12.35-4.23-4.45-5.85-10.89-1.58-11.95.05-12.35z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m220.12 312.59c.42 1.44-3.83 3.93-9.5 5.59s-10.6 1.83-11 .4 3.83-3.93 9.5-5.58 10.6-1.84 11-.41z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m187.81 302.28c1.78-.5 4.83 4.83 6.8 11.9s2.12 13.2.34 13.7-4.83-4.83-6.81-11.9-2.12-13.2-.33-13.7z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m215.85 321.8c.71 1.44-3.35 4.89-9.08 7.71s-10.94 3.91-11.65 2.47 3.35-4.9 9.08-7.71 10.94-3.92 11.65-2.47z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m182.53 315.06c1.91-.66 5.56 4.94 8.15 12.5s3.13 14.22 1.23 14.87-5.56-4.95-8.15-12.5-3.14-14.22-1.23-14.87z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m210.43 335.54c1 1.39-2.57 5.9-8.1 10.07s-10.85 6.43-11.91 5 2.58-5.91 8.1-10.08 10.86-6.42 11.91-5z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m174.66 324.89c2-.89 6.42 4.64 10 12.36s4.86 14.7 2.91 15.6-6.41-4.63-10-12.35-4.86-14.71-2.91-15.61z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m315.48 343.5c1.55 1.09-.69 6.93-5 13.05s-9.05 10.19-10.6 9.11.7-6.93 5-13.05 9.06-10.19 10.6-9.11z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m276.35 346.13c1.18-1.42 6.68 1.21 12.3 5.87s9.22 9.59 8 11-6.68-1.21-12.3-5.87-9.22-9.59-8-11z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m301.76 331.55c1.7.4 1.78 6.19.19 12.92s-4.28 11.87-6 11.47-1.78-6.19-.18-12.93 4.27-11.87 6-11.46z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m269.74 331.81c1-1.43 6.43.66 12.09 4.68s9.43 8.43 8.42 9.86-6.43-.67-12.09-4.68-9.43-8.43-8.42-9.86z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m291.74 316.21c1.68.18 2.48 5.72 1.79 12.38s-2.61 11.91-4.29 11.74-2.49-5.72-1.8-12.38 2.62-11.91 4.3-11.74z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m260 318.06c.81-1.49 6.25-.1 12.15 3.11s10 7 9.22 8.5-6.25.1-12.15-3.11-10-7-9.22-8.5z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m281.3 302c1.6 0 2.84 5.17 2.78 11.51s-1.42 11.47-3 11.46-2.84-5.18-2.77-11.52 1.42-11.47 3-11.45z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m249.74 307.67c.49-1.57 5.91-1.29 12.11.62s10.85 4.73 10.37 6.3-5.91 1.29-12.11-.63-10.85-4.73-10.37-6.29z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m270.34 288c1.56-.15 3.3 4.76 3.87 11s-.23 11.34-1.8 11.48-3.3-4.76-3.87-11 .23-11.34 1.8-11.48z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m243.85 295.4c.57-1.51 5.89-.89 11.87 1.37s10.37 5.34 9.8 6.85-5.89.89-11.87-1.38-10.37-5.33-9.8-6.84z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m259.2 277.35c1.39-.29 3.47 3.93 4.63 9.43s1 10.2-.4 10.49-3.46-3.92-4.63-9.42-1-10.2.4-10.5z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m239 273.63c1.15-1 5.39 1.83 9.47 6.38s6.45 9.08 5.3 10.11-5.39-1.82-9.47-6.38-6.45-9.08-5.3-10.11z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m204.29 377.37a2.29 2.29 0 0 1 -4.38-1.33 6.84 6.84 0 0 0 -1.76-6.79 4.74 4.74 0 0 0 -1.84-1.16 2.48 2.48 0 0 0 -1.57 0c-1.34.5-2.6 2.31-3.29 6.05-1 5.6 0 9 1.57 10.67a4.17 4.17 0 0 0 1.55 1.07 2.62 2.62 0 0 0 1.28.18c.36-.06.64-.2.71-.41a2.28 2.28 0 0 1 4.31 1.5 5.26 5.26 0 0 1 -4.38 3.43 7.15 7.15 0 0 1 -3.55-.43 8.58 8.58 0 0 1 -3.26-2.23c-2.42-2.61-4.05-7.32-2.71-14.6 1-5.6 3.45-8.51 6.19-9.52a7 7 0 0 1 4.47-.09 9.26 9.26 0 0 1 3.71 2.25 11.46 11.46 0 0 1 2.95 11.39z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m206.83 398.45a2.29 2.29 0 1 1 -4.4-1.25c1.73-6.05 8.33-21.16 8.35-21.21a2.28 2.28 0 0 1 3-1.17 2.32 2.32 0 0 1 1.35 1.82c.32 1.74 3.65 19.81 4.64 26.34a2.29 2.29 0 0 1 -4.53.68c-.63-4.2-2.13-12.64-3.26-18.84-1.93 4.66-4.26 10.48-5.16 13.63z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m206 393.43a2.29 2.29 0 0 1 1.52-4.31l9.48 3.38a2.29 2.29 0 0 1 -1.52 4.31z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m227.19 409.26a2.29 2.29 0 0 1 -4.56.36c-.17-2.16-.35-7-.49-11.84a2.24 2.24 0 0 1 0-1.47c-.17-6.13-.29-12-.31-12.55a2.72 2.72 0 0 1 2.18-2.89 5.66 5.66 0 0 1 2.54 0 11.27 11.27 0 0 1 2.58.88 13.77 13.77 0 0 1 8 12.26c.19 8.27-6.16 7.69-10.33 6.43.13 3.73.27 7.1.41 8.85zm-.81-23.72c.05 2.19.14 6 .25 10 2.12.84 6 1.91 5.93-1.46a9.27 9.27 0 0 0 -5.42-8.22l-.76-.31z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m239.71 390.59a2.28 2.28 0 1 1 .39-4.54l16.48 1.48a2.28 2.28 0 1 1 -.4 4.54z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m254.71 414.87a2.28 2.28 0 0 1 -4.51.73l-4.31-26.28a2.28 2.28 0 1 1 4.5-.73z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m268.37 417a2.28 2.28 0 1 1 -4.54.41s-.6-7.09-1.12-13.32c-.31-3.61-.62-7.29-.86-10.06-.46-5.44.49-11.77 6.52-2.7 2.79 4.21 4.6 6.63 7.37 10.85 4.05 6.18 7.85 12.15 7.86 12.17a2.28 2.28 0 0 1 -3.88 2.41s-3.71-5.83-7.8-12.08c-1.79-2.73-3.64-5.51-5.24-7.85l.59 6.88c.61 7.29 1.1 13.24 1.1 13.29z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m265.47 409.08a2.29 2.29 0 1 1 -.32-4.56l9.75-.71a2.29 2.29 0 0 1 .32 4.56z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m274.48 388.82a2.29 2.29 0 0 1 4-2.24l14.38 25.71a2.29 2.29 0 1 1 -4 2.23z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m297.27 379.14a2.28 2.28 0 1 1 3.68-2.68l17.21 23.61a2.27 2.27 0 0 1 -2.93 3.33l-22.43-12.33 11.48 16.3a2.29 2.29 0 0 1 -3.74 2.63l-17.13-24.34a2.28 2.28 0 0 1 2.93-3.36l22.1 12.16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m480.77 467.37c-3.9 0-8.12 3.57-3.25 12.66s5.2 14.28 14.93 11.36 46.08-12.66 52.24-14.6 1.3-5.85 0-13.63.33-9.74-7.13-8.77-36 8.77-56.79 13z",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  d: "m695.43 310.89c4.45 0 8.05 5.38 8.05 12s-3.6 12-8.05 12-8-5.39-8-12 3.6-12 8-12zm.61 4.7c2.59 0 4.69 3.14 4.69 7s-2.1 7-4.69 7-4.69-3.14-4.69-7 2.1-7 4.69-7zm57.9-37.74c2.26 0 4.1 5.38 4.1 12s-1.84 12-4.1 12-4.1-5.38-4.1-12 1.83-12 4.1-12zm.14 5c.83 0 1.51 3.13 1.51 7s-.68 7-1.51 7-1.51-3.13-1.51-7 .67-7 1.51-7z",
  fill: "#333",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m657.54 405.66a24.87 24.87 0 1 1 -24.87 24.86 24.86 24.86 0 0 1 24.87-24.86z",
  fill: "#dbc98c",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m658.83 410.18a19.7 19.7 0 1 1 -19.7 19.7 19.7 19.7 0 0 1 19.7-19.7z",
  fill: "#fcf0c7",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m478 466.84c-4.26 0-8.86 3.9-3.55 13.82s5.67 15.59 16.3 12.4 50.3-13.82 57-15.94 1.41-6.38 0-14.88.35-10.63-7.8-9.57-39.32 9.57-62 14.17z",
  fill: "#c29e33",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m134.78 418.06c0 3.57 4.3 20.07 10.41 25.94s6.12 1.52 11-3.57 7.65-6.38 10.71-5.36 3.58-2.72-2.28-8.58-8.13-8.34-9.2-13.32-2.37-10.68-11-7.59-12.22.83-9.58 12.48z",
  fill: "#c29e33",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m126.36 217.62a10.72 10.72 0 0 0 -2.28 5.35c-.32 2.72-1.16 2.31 1 5 2.31 2.88 6.07 5.54 11.43 7.56 8.9 3.35 22 4.9 40 2.91 24.93-2.77 56 .33 86.52 5.5s60.28 12.37 83 17.86c36.4 8.83 85.63 6 135.05 3.15 11.44-.65 22.9-1.31 34.38-1.84 37-1.68 126.8-10.48 192.18-27.48 40.35-10.49 69.31-21.43 71.79-37.79h.32c-.12 4.08 1.19 5.57.47 9.45-11.37 13.27-38.36 24.07-71.43 32.67-65.79 17.17-156.03 26.04-193.17 27.71-11.23.51-22.79 1.18-34.34 1.84-49.73 2.87-99.29 5.72-136.37-3.27-22.58-5.47-52.34-12.66-82.64-17.79s-60.82-8.19-85.27-5.45c-18.75 2.08-32.6.4-42.11-3.18-6.18-2.33-10.6-5.49-13.39-9-2.09-2.61-1.58-2.11-1.94-4.91a66.92 66.92 0 0 1 6.78-8.3z",
  fill: "#a8b5c2"
}));

function SvgAdrift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 754.33 556.38",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdrift);
export default __webpack_public_path__ + "static/media/adrift.9a95ac11.svg";
export { ForwardRef as ReactComponent };